import React from "react";
import { useSiteMetadata } from "../hooks/use-site-metadata";

interface SEOProps {
    title?: string;
    description?: string;
    pathname?: string;
    image?: string;
    children?: React.ReactNode;
    imageWidth?: number;
    imageHeight?: number;
}

export const SEO = ({
    title,
    description,
    pathname,
    image,
    children,
    imageWidth,
    imageHeight,
}: SEOProps) => {
    const {
        title: defaultTitle,
        description: defaultDescription,
        image: defaultImage,
        siteUrl,
        twitterUsername,
    } = useSiteMetadata();

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: `${siteUrl}${image || defaultImage}`,
        url: `${siteUrl}${pathname || ``}`,
        twitterUsername,
        imageWidth: imageWidth || null,
        imageHeight: imageHeight || null,
        ogtype: pathname ? "article" : "website",
    };

    return (
        <>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            <link rel="canonical" href={seo.url} />


            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:url" content={seo.url} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />
            <meta name="twitter:creator" content={seo.twitterUsername} />

            <meta property="og:site_name" content="Cronicle Press" />
            <meta property="og:url" content={seo.url} />
            <meta property="og:locale" content="en_US" />
            <meta property="og:description" content={seo.description} />
            <meta property="og:title" content={seo.title} />
            <meta property="og:type" content={seo.ogtype} />
            <meta property="og:image" content={seo.image} />
            {seo.imageWidth && (
                <meta
                    property="og:image:width"
                    content={seo.imageWidth.toString()}
                />
            )}
            {seo.imageHeight && (
                <meta
                    property="og:image:height"
                    content={seo.imageHeight.toString()}
                />
            )}

            {children}


        </>
    );
};
